import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {observer, inject} from 'mobx-react';
import {Link} from 'react-router-dom';
import intl from 'react-intl-universal';

import './EmptyResponseMessage.css';


@inject("appStore")
@observer
class EmptyResponseMessage extends Component {

    constructor(props) {
        super(props);

        this.state  = {
            portalElem: null,
        };
    }

    componentDidMount() {
        this.setState({ portalElem: document.querySelector('.ComapFrontend') });
    }

    render() {
        const { map } = this.props.appStore.appConfig.content;

        return this.state.portalElem ? (
            ReactDOM.createPortal((
                <div className={`empty-response-modal ${this.props.visible ? 'active' : ''}`}>
                    <div className="empty-response-modal-gutter" onClick={() => this.props.setVisible(false)} />
                    <div className="empty-response-modal-content">
                        <p className="blue-text">
                            {map['bypass_header']}
                        </p>

                        <div className="callout">
                            <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                            <div className="callout-content" dangerouslySetInnerHTML={{ __html: map['bypass_content'] }} />
                        </div>

                        <div className="buttons">
                            <Link to={'/survey'} onClick={() => this.props.setVisible(false)}>{intl.get("MapContainer.continue")}</Link>
                            <button onClick={() => this.props.setVisible(false)}>{intl.get("MapContainer.back_button")}</button>
                        </div>
                    </div>
                </div>
            ), this.state.portalElem)
        ) : null;
    }

}


export default EmptyResponseMessage;



// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/EmptyResponseMessage/index.js